import { useFormContext, RegisterOptions } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { RadioWrapper } from './styles';
import { ReactNode, useEffect } from 'react';
import { Radio } from '@mantine/core';

interface IProps {
  name: string;
  registerOptions?: RegisterOptions;
  label?: ReactNode | string;
  className?: string;
  onChange: (value: any) => void;
  value: string;
  checked?: boolean;
  disabled?: boolean;
}

export function CustomRadioInput({
  name,
  registerOptions,
  label,
  className,
  value,
  checked,
  disabled,
  onChange,
  ...rest
}: IProps) {
  const { register, formState } = useFormContext();
  const { errors } = formState;

  const { ref, ...registerProps } = register(name, registerOptions);

  return (
    <RadioWrapper className={className}>
      <label>
        <Radio
          {...registerProps}
          ref={ref}
          checked={checked}
          value={value}
          onChange={(event) => {
            registerProps.onChange(event);
            onChange(event.currentTarget.value);
          }}
          disabled={disabled}
          size={"8px"}
          color="rgba(0, 0, 0, 1)"
          variant="outline"
          {...rest}
        />
        {label && <p>{label}</p>}
      </label>
      {!!errors && !!errors[name] && (
        <div className="ErrorMessageStyle">
          <ErrorMessage
            errors={errors}
            name={name}
            render={({ message }) => <p>{message}</p>}
          />
        </div>
      )}
    </RadioWrapper>
  );
}
